// import React, { createContext, useContext, useReducer, useState } from 'react'
// import reducer from "../allcoursecontaxt/Allcoursereducer"
// import { useEffect } from 'react';
// import { BASE_URL } from '../../Config/Config';
// import { useTheme } from 'styled-components';

// const Coursecontaxt = createContext();
// const  initialstate =  {
//     instructer_detail:[],
//     single_instructer:[],
//     real_course:[],   
//     Allcourse:[],    
//     all_product :[] , 
//     singleCourse:[], 
//     grid_view :true,
//     filters : {
//         text:"",
//         categoryname : [],
//         price:"",
//         instructor : [] 
//    }
// }

// const  AllCourseprovider  = ({children})=>{
//   const[openinstructer , setopeninstructer] = useState(false); 

//  const API = `${BASE_URL}/coursemaster/`;
//  const Instructorapi  =  `${BASE_URL}/courseinstructor/`


// const[state , dispatch] = useReducer(reducer , initialstate);

// const [loading , setloading] = useState(true);
// const [singlecourseloading , setsinglecourseloading] = useState(true);

//     const setgridview = ()=>{
//       return dispatch({type :'SET GRID_VIEW'});
//     }
//     const setlistview = ()=>{
//       return dispatch({type :'SET LIST_VIEW'});
//     }


//    const Getallcourse = async(URL)=>{
//     dispatch({type:"SET_LOADING"});
//     setloading(true);
//    const response = await fetch(URL,{
//     method:'GET',
//     headers:{
//       'content-type': "application/json"
//     },
//     credentials: "include",
//    });
//     if(!response){
//       console.log("faild fatching data");
//     }
//     else{
//       const allcourse = await response.json();
//       dispatch({type : 'SET ALL COURSE DATA',payload : allcourse.data});
//      }
//        setloading(false);
//    }

// const getsinglecourse = async (id) => {
//   try {
//     setsinglecourseloading(true);
//       // Make an API call to fetch course data by slug (id)
//       const response = await fetch(`${BASE_URL}/coursemaster/${id}`);
//       if (!response.ok) {
//           throw new Error("Failed to fetch course data");
//       }
//       const course = await response.json();
//       dispatch({ type: "GET_SINGLE_COURSE", payload: course.data });
//   } catch (error) {
//       console.error("Error fetching course:", error);
//   }
//   finally{
//     setsinglecourseloading(false);
//   }
// };

//   const updatefiltervalue = (event)=>{
//       const name =  event.target.name;
//       const value =  event.target.value;
//       return dispatch({type : 'UPDATE_FILTER_VALUE', payload:{name,value}});
//   }

//    useEffect(()=>{
//       dispatch({type:"FILTER_PRODUCTS"});
//     },[state.filters,state.real_course]);

//    useEffect(()=>{
//     Getallcourse(API);
//    },[]);


// const Instructordetail = async(URL)=>{
//   const response = await fetch(URL,{
//     method:'GET',
//     headers:{
//       'content-type': "application/json"
//     },
//     credentials: "include",
//    });
//     if(!response){
//       console.log("faild fatching data");
//     }
//     else{
//       const instructer = await response.json();
//       dispatch({type:'SET_INSTRUCTER_DATA',payload:instructer.data });  
//      } 
// }
// useEffect(()=>{
//   Instructordetail(Instructorapi);
// },[]);
        


// const Getsingleinstructer = async (slug) => {

//   try {
//     // Fetch instructor data from the backend API
//     const response = await fetch(`${BASE_URL}/courseinstructor/${slug}`);
//     const data = await response.json();

//     if ( !data.data.length > 0) {
//       // If instructor data is found, dispatch the action
//       dispatch({ type: 'GET_SINGLE_INSTRUCTER', payload: data.data });
//     } else {
//       // If no instructor is found, handle the case
//       console.warn(`Instructor with ID ${slug} not found.`);
//       dispatch({ type: 'GET_SINGLE_INSTRUCTER', payload: null });
//     }
//   } catch (error) {
//     // Handle any errors during the API call
//     console.error("Error fetching instructor:", error);
//     dispatch({ type: 'GET_SINGLE_INSTRUCTER', payload: null });
//   }

//   // Open the instructor detail modal or section
//   setopeninstructer(true);
// };


// const handleClose = ()=>{
//   setopeninstructer(false);
// }


// return (
//    <Coursecontaxt.Provider value={{...state , setgridview , getsinglecourse , setlistview , updatefiltervalue , loading , Getsingleinstructer ,  setopeninstructer , openinstructer , handleClose , singlecourseloading  , dispatch}}>
//        {children}
//    </Coursecontaxt.Provider>
//   );
// }
// const  UseGlobelcourse = ()=>{
//     return useContext(Coursecontaxt);
// }
// export { AllCourseprovider , UseGlobelcourse , Coursecontaxt }


import React, { createContext, useContext, useReducer, useState, useEffect } from 'react';
import reducer from "../allcoursecontaxt/Allcoursereducer";
import { BASE_URL } from '../../Config/Config';
import { useQuery } from '@tanstack/react-query';

const Coursecontaxt = createContext();

const initialstate = {
  instructer_detail: [],
  single_instructer: [],
  real_course: [],
  Allcourse: [],
  all_product: [],
  singleCourse: [],
  grid_view: true,
  filters: {
    text: "",
    categoryname: [],
    price: "",
    instructor: []
  }
};

const AllCourseprovider = ({ children }) => {

  const [openinstructer, setopeninstructer] = useState(false);

  const API = `${BASE_URL}/coursemaster/`;
  const Instructorapi = `${BASE_URL}/courseinstructor/`;

  const [state, dispatch] = useReducer(reducer, initialstate);

  // ===========================================================
  // 1) FETCH ALL COURSES USING USEQUERY
  // ===========================================================
  const { data: courseData, isLoading: loading } = useQuery({
    queryKey: ["all-courses"],
    queryFn: async () => {
      const res = await fetch(API, {
        method: "GET",
        headers: { "content-type": "application/json" },
        credentials: "include"
      });
      return res.json();
    }
  });

  useEffect(() => {
    if (courseData?.data) {
      dispatch({ type: "SET ALL COURSE DATA", payload: courseData.data });
    }
  }, [courseData]);


  // ===========================================================
  // 2) FETCH ALL INSTRUCTORS USING USEQUERY
  // ===========================================================
  const { data: instructorData } = useQuery({
    queryKey: ["all-instructors"],
    queryFn: async () => {
      const res = await fetch(Instructorapi, {
        method: "GET",
        headers: { "content-type": "application/json" },
        credentials: "include"
      });
      return res.json();
    }
  });

  useEffect(() => {
    if (instructorData?.data) {
      dispatch({ type: 'SET_INSTRUCTER_DATA', payload: instructorData.data });
    }
  }, [instructorData]);


  // ===========================================================
  // 3) FETCH SINGLE COURSE USING USEQUERY
  // ===========================================================
  const [singleId, setSingleId] = useState(null);

  const { data: singleCourseData, isLoading: singlecourseloading } = useQuery({
    queryKey: ["single-course", singleId],
    queryFn: async () => {
      const res = await fetch(`${BASE_URL}/coursemaster/${singleId}`);
      return res.json();
    },
    enabled: !!singleId
  });

  
  const getsinglecourse = (id) => {
      setSingleId(id);
  };

  useEffect(() => {
    if (singleCourseData?.data) {
      dispatch({ type: "GET_SINGLE_COURSE", payload: singleCourseData.data });
    }
  }, [singleCourseData ]);


  // ===========================================================
  // 4) FETCH SINGLE INSTRUCTOR USING USEQUERY
  // ===========================================================
  const [instSlug, setInstSlug] = useState(null);

const {
  data: singleInstructor,
  isLoading,
} = useQuery({
  queryKey: ["single-instructor", instSlug],
  queryFn: async () => {
    const res = await fetch(`${BASE_URL}/courseinstructor/${instSlug}`);
    return res.json();
  },
  enabled: !!instSlug,

  // ⬇️ Performance boosters
  staleTime: 1000 * 60 * 5,       // 5 min cache – no re-fetch
  cacheTime: 1000 * 60 * 10,      // 10 min keep in memory
  refetchOnWindowFocus: false,    // Do NOT refetch when tab active
  placeholderData: (prev) => prev // Show previous data instantly
});


  const Getsingleinstructer = (slug) => {
    setInstSlug(slug);
    setopeninstructer(true);
  };

  useEffect(() => {
    if (singleInstructor?.data) {
      dispatch({ type: 'GET_SINGLE_INSTRUCTER', payload: singleInstructor.data });
    }
  }, [singleInstructor]);


  // ===========================================================
  // OTHER FUNCTIONS (no change)
  // ===========================================================
  const setgridview = () => dispatch({ type: 'SET GRID_VIEW' });
  const setlistview = () => dispatch({ type: 'SET LIST_VIEW' });

  const updatefiltervalue = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    dispatch({ type: 'UPDATE_FILTER_VALUE', payload: { name, value } });
  };

  // FILTER products
  useEffect(() => {
    dispatch({ type: "FILTER_PRODUCTS" });
  }, [state.filters, state.real_course]);


  const handleClose = () => setopeninstructer(false);


  return (
    <Coursecontaxt.Provider value={{
      ...state,
      loading,
      singlecourseloading,
      setgridview,
      setlistview,
      updatefiltervalue,
      getsinglecourse,
      Getsingleinstructer,
      openinstructer,
      setopeninstructer,
      handleClose,
      dispatch
    }}>
      {children}
    </Coursecontaxt.Provider>
  );
};

const UseGlobelcourse = () => useContext(Coursecontaxt);

export { AllCourseprovider, UseGlobelcourse, Coursecontaxt };
